const marketingCards = [
    {
        url: 'https://tinyurl.com/ufpcnar',
        caption: 'Doctor',
        title: 'Qualifying Medical Conditions',
        description: 'Find out if you qualify to recieve benefits of Medical Marijuana.'
    },

    {
        url: 'https://tinyurl.com/tr4sjw3',
        caption: 'Marijuana in jars',
        title: 'Qualifying Medical Conditions',
        description: 'Find out if you qualify to recieve benefits of Medical Marijuana.'
    },

    {
        url: 'https://tinyurl.com/wovebbj',
        caption: 'Handshake',
        title: 'Frequently Asked Questions',
        description: 'Do you have questions? We are here to help! Click read more below for a list of answers to commonly asked questions.'
    }
]

export default marketingCards;
